import React from 'react';
import { useAppSelector } from 'flow/hooks/useRedux';
import {
    selectWaitingQueueItemJoinTime,
    selectWaitingQueueItemPosition,
} from 'flow/selectors/queue-selectors';
import { QueueCallQueueKey, TicketKey } from 'flow/types/EntityKeys';

import QueuePositionWithTime from 'flow/components/ui-components/QueuePositionWithTime';
import SectionHeaderTime from './SectionHeaderTime';

type Props = {
    ticketKey: TicketKey;
    waitingQueueItemKey: QueueCallQueueKey;
};

const SectionHeaderQueuePosition = ({
    ticketKey,
    waitingQueueItemKey,
}: Props) => {
    const joinTime = useAppSelector((state) =>
        selectWaitingQueueItemJoinTime(state, waitingQueueItemKey),
    );
    const position = useAppSelector((state) =>
        selectWaitingQueueItemPosition(state, waitingQueueItemKey),
    );

    // The item can transiently be present in byKey but absent from the
    // ordered byQueue list; keep the header slot's always-something invariant
    // by falling back to the timestamp rather than rendering nothing.
    if (!position) return <SectionHeaderTime ticketKey={ticketKey} />;

    return <QueuePositionWithTime number={position} joinTime={joinTime} />;
};

export default React.memo(SectionHeaderQueuePosition);
